import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-background-950"></i>
              </div>
              <span className="text-lg font-bold text-foreground-100 font-heading">大师兄影视</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              汇聚全网热门影视，高清免费在线观看，秒开播放不缓冲，畅享极致观影体验。
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-200 mb-4">影视分类</h5>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-200 mb-4">快速链接</h5>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <a href="/about#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            </div>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-200 mb-4">联系方式</h5>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-foreground-500">contact@dashixiong.tv</p>
              <p className="text-sm text-foreground-500">400-888-8888</p>
              <p className="text-sm text-foreground-500">北京市朝阳区望京SOHO</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 大师兄影视 版权所有 | 仅供学习交流，请支持正版
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line text-base"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line text-base"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bilibili-line text-base"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}